import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

export function ErrorInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  let nextRequest = req;
  let canShowErrorNotification = true;

  if (nextRequest.headers.has('canShowErrorNotification')) {
    canShowErrorNotification = nextRequest.headers.get('canShowErrorNotification')?.toLowerCase() === 'true';
    nextRequest = nextRequest.clone({
      headers: req.headers.delete('canShowErrorNotification'),
    });
  }

  return next(nextRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log('Error:', error);
      // if (error.status === 401) {
      //   // alert('You are unauthorized. Please log in again.');
      //   localStorage.removeItem('accessToken');
      //   localStorage.removeItem('isAdmin');
      //   localStorage.removeItem('isSuperAdmin');
      //   localStorage.removeItem('isIndividual');
      //   localStorage.removeItem('companyId');
      //   localStorage.removeItem('userId');
      //   return throwError(() => new Error('Unauthorized access'));
      // }

      if (error.error?.error === 'Invalid credentials') {
        return throwError(() => new Error('Invalid credentials provided'));
      }

      return throwError(() => error);
    })
  );
}
